/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
import React from "react";
import Grid from "@mui/material/Grid";
import {
  Input,
  SelectAutocomplete,
  AutoSaveField as Field,
  InlineRadioGroup
} from "../../../../components/Form";
import {
  WAGE_PROTECTION_OPTIONS,
  WAGE_PROTECTION_SYSTEM_ROUTE,
  YES_NO_OPTIONS,
  ACTIVE_PASSIVE_OPTIONS
} from "../../constants";
import { RadioButtonRoot } from "../styled";
import PropTypes from "prop-types";
import { Label } from "./styled";

export const CompanyDetails = ({ values }) => {
  return (
    <>
      <Grid container spacing={3} sx={{ mt: 0 }}>
        <Grid item sm={12} xs={12}>
          <Field
            name="wageProtectionSytemSpaceType"
            path="prospect.organizationInfo.wageProtectionSytem.spaceType"
            label={WAGE_PROTECTION_SYSTEM_ROUTE}
            component={InlineRadioGroup}
            options={WAGE_PROTECTION_OPTIONS}
            typeRadio
            contextualHelpProps={{ isDisableHoverListener: false }}
          />
        </Grid>
      </Grid>
      <Grid container spacing={3} sx={{ mt: 1 }}>
        <Grid item sm={12} xs={12}>
          <Field
            name="wageProtectionSytemOther"
            path="prospect.organizationInfo.wageProtectionSytem.others"
            label="Please Specify"
            component={Input}
            InputProps={{
              inputProps: {
                tabIndex: 0
              }
            }}
          />
        </Grid>
      </Grid>
      <Grid container spacing={3} sx={{ mt: 0, rowGap: "16px" }}>
        <Grid item sm={12} xs={12}>
          <Label> Tell us about your Premises </Label>
        </Grid>
        <Grid item sm={6} xs={12}>
          <Field
            name="makani"
            path="prospect.organizationInfo.addressDetails.makaniNumber"
            label="Ejari Number"
            component={Input}
            InputProps={{
              inputProps: {
                tabIndex: 0
              }
            }}
          />
        </Grid>
        <Grid
          item
          sm={6}
          xs={12}
          sx={{
            mt: {
              xs: 2,
              sm: 0
            }
          }}
        >
          <Field
            name="shoporOfficeNumber"
            path="prospect.organizationInfo.addressDetails.addressLine1"
            label="Office/Shop Number"
            component={Input}
            InputProps={{
              inputProps: {
                tabIndex: 0
              }
            }}
          />
        </Grid>
      </Grid>
      <Grid container spacing={3} sx={{ mt: 1 }}>
        <Grid item xs={12}>
          <Field
            name="buildingNameOrNoOfFloor"
            path="prospect.organizationInfo.addressDetails.addressLine3"
            label="Builiding name / no / or floor"
            component={Input}
            InputProps={{
              inputProps: {
                tabIndex: 0
              }
            }}
          />
        </Grid>
      </Grid>
      <Grid container spacing={3} sx={{ mt: 1 }}>
        <Grid item sm={6} xs={12}>
          <Field
            name="streetName"
            path="prospect.organizationInfo.addressDetails.addressLine2"
            label="Street name"
            component={Input}
            InputProps={{
              inputProps: {
                tabIndex: 0
              }
            }}
          />
        </Grid>
        <Grid
          item
          sm={6}
          xs={12}
          sx={{
            mt: {
              xs: 3,
              sm: 0
            }
          }}
        >
          <Field
            name="areaOrDistrict"
            path="prospect.organizationInfo.addressDetails.addressLine4"
            label="Area or District"
            component={Input}
            InputProps={{
              inputProps: {
                tabIndex: 0
              }
            }}
          />
        </Grid>
      </Grid>

      <Grid container spacing={3} sx={{ mt: 1 }}>
        <Grid item sm={6} xs={12}>
          <Field
            name="emirate"
            path="prospect.organizationInfo.addressDetails.emirateCity"
            label="Emirate"
            component={SelectAutocomplete}
            datalistId="emirateCity"
            tabIndex="0"
            isSearchable
          />
        </Grid>
        <Grid
          item
          sm={6}
          xs={12}
          sx={{
            mt: {
              xs: 3,
              sm: 0
            }
          }}
        >
          <Field
            name="poBoxNumber"
            path="prospect.organizationInfo.addressDetails.poBox"
            label="P.O Box Number"
            component={Input}
            InputProps={{
              inputProps: { tabIndex: 0 }
            }}
          />
        </Grid>
      </Grid>

      <>
        <h3 style={{ margin: 0 }}>FATCA US Tax relationship</h3>
        <Field
          name="companyUsEntity"
          path="prospect.organizationInfo.fatcaIsUSEntity"
          label="Is this company a US entity"
          component={InlineRadioGroup}
          options={YES_NO_OPTIONS}
          classes={{ root: RadioButtonRoot }}
          typeRadio
          contextualHelpProps={{ isDisableHoverListener: false }}
        />
        {values.companyUsEntity === "yes" && (
          <Field
            name="entityOrganizedInUSA"
            path="prospect.organizationInfo.fatcaIsEntityUnderUSLaw"
            label="Is the entity organized in the US or under the laws of the US or any state thereof?"
            component={InlineRadioGroup}
            options={YES_NO_OPTIONS}
            classes={{ root: RadioButtonRoot }}
            typeRadio
            contextualHelpProps={{ isDisableHoverListener: false }}
          />
        )}
        {values.companyUsEntity === "yes" && values.entityOrganizedInUSA === "yes" && (
          <Field
            name="reportable"
            path="prospect.organizationInfo.reportable"
            label="Is this reportable?"
            component={InlineRadioGroup}
            options={YES_NO_OPTIONS}
            classes={{ root: RadioButtonRoot }}
            typeRadio
            contextualHelpProps={{ isDisableHoverListener: false }}
          />
        )}
        <Field
          name="companyFinancialInsitution"
          path="prospect.organizationInfo.fatcaIsFinancialInst"
          label="Is this company a financial insitution?"
          component={InlineRadioGroup}
          options={YES_NO_OPTIONS}
          classes={{ root: RadioButtonRoot }}
          typeRadio
          contextualHelpProps={{ isDisableHoverListener: false }}
        />
        {values.companyFinancialInsitution === "yes" && (
          <Field
            name="globalIntermediaryIDNumber"
            path="prospect.organizationInfo.fatcaGlobalIntermediaryIDNo"
            component={Input}
            label="Global Intermediary Identification Number"
            InputProps={{
              inputProps: {
                tabIndex: 0,
                maxLength: 20
              }
            }}
          />
        )}
        {values.companyFinancialInsitution === "no" && (
          <Field
            name="nonFinancialType"
            path="prospect.organizationInfo.typeOfNonFinancialEntity"
            label="Type of Non Financial Entity"
            component={InlineRadioGroup}
            options={ACTIVE_PASSIVE_OPTIONS}
            classes={{ root: RadioButtonRoot }}
            typeRadio
            contextualHelpProps={{ isDisableHoverListener: false }}
          />
        )}
      </>
    </>
  );
};
CompanyDetails.propTypes = {
  values: PropTypes.object.isRequired
};
